import { z } from "zod";

export const authUserSchema = z.object({
  id: z.string(),
  email: z.string(),
  name: z.string().nullable(),
  role: z.enum(["admin", "operator", "viewer"]),
});

export const idsTenantSchema = z.object({
  name: z.string(),
  domain: z.string(),
  isAdmin: z.boolean(),
});

export const authMeResponseSchema = z.object({
  user: authUserSchema,
  // Lowercased IDS company domains the user has access to / is admin of.
  // Frozen at OIDC login time (no live IDS round-trip per request) — the
  // user re-logs in to refresh these grants.
  adminDomains: z.array(z.string()).default([]),
  tenantDomains: z.array(z.string()).default([]),
  // Full IDS tenant list — name+domain+isAdmin — for picker UIs that
  // need friendly names. Same set as tenantDomains/adminDomains but
  // with display strings attached.
  idsTenants: z.array(idsTenantSchema).default([]),
});

export type AuthUser = z.infer<typeof authUserSchema>;
export type AuthMeResponse = z.infer<typeof authMeResponseSchema>;
export type IdsTenant = z.infer<typeof idsTenantSchema>;
